import { apiEmpleo } from "../../util/ApiEmpleo";

export const PREFILTER_CANDIDATE_MAX_RESULTS = "PREFILTER_CANDIDATE_MAX_RESULTS";
export const PREFILTER_AUTO_BOT_ENABLED = "PREFILTER_AUTO_BOT_ENABLED";

export type TSetting = {
  key: string;
  value: string;
};

// Mismos valores que acepta FILTER_VALIDATE_BOOLEAN en el core, que es quien
// lee estos settings de tipo *_ENABLED. Si el setting no existe, está apagado.
const TRUTHY_SETTING_VALUES = ["1", "true", "on", "yes"];

export const isSettingEnabled = (setting: TSetting): boolean =>
  TRUTHY_SETTING_VALUES.includes(setting.value.trim().toLowerCase());

const apiGetSetting = async (key: string): Promise<TSetting> => {
  const res: TSetting = await apiEmpleo.get(`settings/${key}`);

  return res;
};

export { apiGetSetting };
